import { render, staticRenderFns } from "./hierarchy-display.vue?vue&type=template&id=23fccf36&scoped=true&"
import script from "./hierarchy-display.vue?vue&type=script&lang=ts&"
export * from "./hierarchy-display.vue?vue&type=script&lang=ts&"
import style0 from "./hierarchy-display.vue?vue&type=style&index=0&id=23fccf36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fccf36",
  null
  
)

export default component.exports